import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { EmpruntService } from '../../services/emprunt.service';
import { RequeteRetournerEmprunt } from '../../services/requetes/requete-retourner-emprunt';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-emprunt-retour-succes',
    templateUrl: './emprunt-retour-succes.component.html',
    providers: [MessageService]
})
export class EmpruntRetourSuccesComponent implements OnInit {

    empruntId: number;
    isLoading: boolean = true;
    isSuccess: boolean = false;
    errorMessage: string = '';

    constructor(
        private route: ActivatedRoute,
        private breadcrumbService: BreadcrumbService,
        private empruntService: EmpruntService,
        private messageService: MessageService
    ) {
        this.breadcrumbService.setItems([
            { label: 'Emprunts', routerLink: '/emprunt' },
            { label: 'Retour d\'emprunt' }
        ]);
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.empruntId = params.id ? +params.id : null;
            
            if (this.empruntId) {
                this.processReturnEmprunt();
            } else {
                this.isLoading = false;
                this.errorMessage = 'Aucun numéro d\'emprunt fourni';
            }
        });
    }

    private processReturnEmprunt(): void {
        const requete: RequeteRetournerEmprunt = {};
        const emplacementIdParam = this.route.snapshot.queryParamMap.get('EmplacementId');
        if (emplacementIdParam) {
            const parsedEmplacementId = Number(emplacementIdParam);
            if (!Number.isNaN(parsedEmplacementId)) {
                requete.emplacementId = parsedEmplacementId;
            }
        }

        this.empruntService.retournerEmprunt(this.empruntId, requete).subscribe({
            next: () => {
                this.isLoading = false;
                this.isSuccess = true;
            },
            error: (error) => {
                this.isLoading = false;
                this.isSuccess = false;
                this.errorMessage = error.error || error;
            }
        });
    }
} 